export function getPackageFromList(packList, idToFind) {
  const foundPack = packList.find((pack) => {
    return pack.id === idToFind;
  });
  return foundPack;
}
